import DOMPurify from "dompurify";

export function sanitizeHTML(html: string): string {
    return DOMPurify.sanitize(html, {ADD_ATTR: ["target"]});
}